export default __webpack_public_path__ + "static/media/nft3.4e35cbfc.jpg";